export default {
  nav: {
    dashboard: 'Dashboard',
    markets: 'Markets',
    trade: 'Trade',
    support: 'Support',
    profile: 'Profile'
  },
  trade: {
    title: 'Trade',
    spot: 'Spot',
    futures: 'Futures',
    copytrading: 'Copytrading',
    leaderboard: 'Leaderboard',
    myTraders: 'My Traders',
    myTrades: 'My Trades',
    becomeTrader: 'Become Trader',
    buy: 'Buy',
    sell: 'Sell',
    price: 'Price',
    amount: 'Amount',
    total: 'Total',
    available: 'Available',
    margin: 'Margin',
    leverage: 'Leverage',
    orderType: 'Order Type',
    limit: 'Limit',
    market: 'Market',
    tpsl: 'TP/SL',
    openChart: 'Open Chart',
    selectToken: 'Select Token',
    positionsHistory: 'Positions History',
    processing: 'Processing...',
    positionOpened: 'Position opened',
    orderPlaced: 'Limit order placed',
    positionClosed: 'Position closed: {pnl}',
    orderCanceled: 'Order canceled',
    tpSlUpdated: 'TP/SL updated',
    editTpSl: 'Edit TP/SL',
    editOrder: 'Edit',
    orderUpdated: 'Order updated',
    tpProfitLabel: 'Take Profit (price)',
    slLossLabel: 'Stop Loss (price)',
    tpSlUsdtNote: 'Enter the trigger PRICE: Take Profit is the price to close in profit, Stop Loss the price to close in loss. For a long, TP is above entry and SL below; for a short, the opposite.',
    save: 'Save',
    closePosition: 'Close',
    confirmCloseTitle: 'Close Position',
    confirmCloseMessage: 'Are you sure you want to close this position at market price?',
    confirmClose: 'Confirm Close',
    confirmOpenTitle: 'Open Position',
    confirmOpenMessage: 'Are you sure you want to open this position?',
    confirmOrderTitle: 'Place Limit Order',
    confirmOrderMessage: 'Are you sure you want to place this limit order?',
    confirmCancelTitle: 'Cancel Order',
    confirmCancelMessage: 'Are you sure you want to cancel this order?',
    confirmCancelOrder: 'Confirm Cancel',
    confirm: 'Confirm',
    tradingBlockedTitle: 'Trading Restricted',
    tradingBlockedMessage: 'Dear user! A critically low margin level has been recorded on your trading account. In order to protect your funds and prevent further losses, your ability to open and close positions has been temporarily restricted. Please contact support to resolve this issue and restore access to trading operations.',
    understood: 'Understood',
    pair: 'Pair',
    direction: 'Direction',
    limitPriceLabel: 'Limit Price',
    cancel: 'Cancel',
    copyTrade: 'Copy Trade',
    cancelOrder: 'Cancel',
    positionsTab: 'Positions',
    historyTab: 'History',
    copyCannotCloseTitle: 'Dear user',
    copyCannotCloseText: 'This position cannot be closed manually because it was opened as part of copytrading. It will be closed automatically only after the trader you follow closes the corresponding position on their account.',
    openOrders: 'Pending Orders',
    noOpenPositions: 'No open positions',
    noOpenOrders: 'No pending orders',
    entryPrice: 'Entry',
    markPrice: 'Mark',
    liqPrice: 'Liq. Price',
    limitPrice: 'Limit Price',
    marginUsed: 'Margin Used',
    equity: 'Equity',
    unrealizedPnl: 'Unrealized PnL',
    errorNoUser: 'Unable to identify user',
    errorEnterAmount: 'Enter a valid amount',
    errorEnterPrice: 'Enter a valid limit price',
    errorInsufficient: 'Insufficient available balance',
    errorGeneric: 'Something went wrong',
    errorNetwork: 'Network error. Please try again',
    copyingActiveTitle: 'Copying Active',
    copyingActiveMessage: 'Your wallet is connected to copytrading. Opening trades on spot and futures markets is currently unavailable as margin is used in active copy positions.\n\nTo restore trading, disconnect from the trader and stop copying trades.',
    spotLockedTitle: 'Spot Trading',
    spotLockedText: 'Dear user,<br><br>Spot trading is available exclusively for users with <strong>VIP</strong> status in the HyperLiquid Mini App.<br><br>Increase your activity level and meet the loyalty program requirements. Once you reach VIP status, access to spot trading will be unlocked automatically.',
    spotYourLevel: 'Your level',
    spotToVip: 'to VIP',
    spotCurrent: 'Current',
    becomeTraderTitle: 'Become a Trader',
    becomeTraderMessage: 'To become a copy trader and earn not only from your own funds, you need to obtain VIP account level.\n\nVIP status opens access to connecting subscribers, allows you to scale trading using their capital, and receive additional rewards from profits on copied trades.',
    cannotCopyTitle: 'Cannot Copy Multiple Traders',
    cannotCopyMessage: 'You cannot copy multiple traders simultaneously as your account has not yet reached Platinum status.\n\nGet Platinum status — and unlock the ability to copy multiple traders and diversify strategies.',
    copying: 'Copying',
    copy: 'Copy',
    roi: 'ROI',
    pnl: 'PnL',
    drawdown: 'Drawdown',
    followers: 'Followers',
    ok: 'OK',
    close: 'Close',
    aum: 'AUM',
    profitDistribution: 'Profit Distribution',
    tradingDays: 'Trading Days',
    stabilityIndex: 'Stability Index',
    overview: 'Overview',
    trades: 'Trades',
    bots: 'Bots',
    performance: 'Performance',
    masterPnl: 'Master P&L',
    winRate: 'Win Rate',
    followersPnl: 'Followers P&L',
    maxDrawdown: 'Max Drawdown',
    avgPnlPerTrade: 'Avg P&L per Trade',
    details: 'Details',
    totalAssets: 'Total Assets',
    profitLossRatio: 'Profit/Loss Ratio',
    performanceChart: 'Performance Chart'
  },
  chart: {
    positionsPnl: 'Positions ({n}) · Unrealized PnL',
    unavailable: 'Real-time chart is unavailable for this asset'
  },
  maintenance: {
    title: 'Dear users!',
    message1: 'Technical maintenance is currently underway to optimize and improve the system.',
    message2: 'Due to this, some features may work unstably or with temporary limitations.',
    message3: 'The application continues to operate normally, access to core functionality is maintained.',
    message4: 'Thank you for your understanding. We are working to ensure everything functions as quickly and stably as possible.',
    button: 'Got it'
  },
  settings: {
    title: 'Settings',
    language: 'Language',
    theme: 'Theme',
    support: 'Support',
    dark: 'Dark',
    light: 'Light'
  },
  profile: {
    title: 'Profile',
    balance: 'Balance',
    withdraw: 'Withdraw',
    totalBalance: 'Your total asset balance',
    viewHistory: 'View Transaction History',
    referrals: 'Referrals',
    referralsCount: '{count} Referrals',
    rewards: 'Rewards',
    rewardsCount: '{count} Rewards',
    rewardsMessage: 'Rewards are credited to your balance automatically',
    yourCode: 'Your code:',
    copy: 'Copy',
    copied: 'Copied!',
    pnl7d: '7D PnL',
    pnl30d: '30D PnL',
    pnl90d: '90D PnL',
    aum: 'AUM',
    roi: 'ROI',
    roi90d: 'ROI (90D)',
    unsubscribe: 'Unsubscribe',
    resume: 'Resume',
    resuming: 'Resuming...',
    inactiveTitle: 'Your request has been successfully accepted!',
    inactiveMessage: 'Funds will be unlocked within 21 days — this time is necessary to close all trades, calculate profits, and properly complete copying. This is done for your safety and capital protection. If you want to continue copying this trader, click the "Resume" button.',
    inviteButton: 'Invite referral & copy together!',
    referralLimitMessage: 'It is currently not possible to connect new referrals to this trader. He has set a limit on the number of users allowed to copy his trades',
    ok: 'Ok',
    vipTier: 'VIP tier',
    yourProgress: 'Your progress',
    currentTier: 'Current tier',
    progressTooltip: 'Your tier progress will grow as you increase your trading activity, deposit activity, and total trading volume.',
    currentExp: 'Current EXP:',
    expToNext: 'EXP to next level:',
    maxLevel: 'Max level reached!',
    unsubscribeConfirm: 'Stop copying trader\'s trades? After disabling, you will stop receiving profit from their trading.',
    no: 'No',
    yes: 'Yes',
    processing: 'Processing...',
    withdrawFunds: 'Withdraw Funds',
    confirmWithdrawal: 'Confirm Withdrawal',
    enterPin: 'Enter PIN Code',
    pinDescription: 'Please enter your PIN code to confirm withdrawal',
    network: 'Network',
    selectNetwork: 'Select network',
    walletAddress: 'Wallet Address',
    enterWallet: 'Enter wallet address',
    amount: 'Amount (USDT)',
    enterAmount: 'Enter amount',
    available: 'Available:',
    minMax: 'Min: {min} USDT | Max: {max} USDT per transaction',
    cancel: 'Cancel',
    continue: 'Continue',
    confirm: 'Confirm',
    back: 'Back',
    withdrawalSubmitted: 'Withdrawal Request Submitted',
    withdrawalMessage: 'Your request is being reviewed, thank you for waiting',
    openPositionsErrorTitle: 'Dear User!',
    openDashboard: 'Open dashboard',
    openPositionsErrorMessage: 'Your request was not processed because your account has open trades using cross-margin.\nPlease close all active positions and try again.',
    transactionHistory: 'Transaction History',
    loadingHistory: 'Loading history...',
    noTransactions: 'No transactions yet',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    pending: 'Pending',
    approved: 'Approved',
    completed: 'Completed',
    declined: 'Declined',
    failed: 'Failed',
    networkLabel: 'Network:',
    addressLabel: 'Address:',
    reasonLabel: 'Reason:',
    noReason: 'No reason provided',
    na: 'N/A',
    levels: {
      bronze: {
        benefit1: 'Regular trading fees',
        benefit2: 'Standard withdrawal limits',
        benefit3: 'Monthly rewards',
        benefit4: 'Margin trading up to 3x leverage'
      },
      silver: {
        benefit1: '5% lower trading fees',
        benefit2: 'Monthly bonuses',
        benefit3: 'Margin trading up to 5x leverage'
      },
      gold: {
        benefit1: '10% lower trading fees',
        benefit2: 'Priority customer support',
        benefit3: 'Early access to new instruments',
        benefit4: 'Margin trading up to 10x leverage'
      },
      platinum: {
        benefit1: '25% lower trading fees',
        benefit2: 'Personal account manager',
        benefit3: 'Invites to private communities',
        benefit4: 'Margin trading up to 50x leverage'
      },
      vip: {
        benefit1: 'Zero trading fees',
        benefit2: 'Complete OTC desk access',
        benefit3: '24/7 VIP manager',
        benefit4: 'Custom limits and terms',
        benefit5: 'Invites to private offline events',
        benefit6: 'Margin trading up to 100x'
      }
    }
  },
  faq: {
    title: 'FAQ / Support',
    footerText: 'If you didn\'t find the answer to your question, feel free to contact',
    customerSupport: 'customer support',
    footerEnd: "for further assistance. Or by email:",
    questions: {
      q1: 'What is copy trading?',
      q2: 'How do I start copying a trader?',
      q3: 'Can I stop copying at any time?',
      q4: 'Who controls my funds?',
      q6: 'What happens if the trader goes into a loss?',
      q7: 'Can I copy multiple traders at the same time?',
      q8: 'How often is trader statistics updated?',
      q9: 'Where can I view my results?',
      q10: 'Can a trader change their strategy?',
      q11: 'Is it safe to copy trades?'
    },
    answers: {
      a1: 'Copy trading is a mechanism that automatically mirrors the trades of a selected trader in real time.',
      a2: 'Choose a trader, click "Connect", and confirm the amount you want to allocate for copying.',
      a3: 'Yes, you can stop copying and close positions at any time, subject to the trader\'s conditions.',
      a4: 'Your funds remain in your personal wallet/exchange account. The trader does not have access to them.',
      a6: 'Losses are distributed proportionally to your allocated amount. The trader does not bear financial responsibility for the outcome.',
      a7: 'Yes, if your balance allows. This can help diversify risk.',
      a8: 'Statistics are updated in real time or with minimal delay.',
      a9: 'In the "Dashboard" or "Profile" section, you can find detailed information about profits, losses, and active positions.',
      a10: 'Yes, traders are free to adjust their strategy at any time, and all changes are automatically reflected in the copied trades.',
      a11: 'Safety depends on the risk level of the trader you choose. We recommend reviewing ROI, PnL, and risk metrics before connecting.'
    }
  },
  markets: {
    title: 'Markets',
    searchPlaceholder: 'Search by name or symbol',
    loadingMarkets: 'Loading markets…',
    unableToLoad: 'Unable to load markets',
    tryAgain: 'Try again',
    nothingFound: 'Nothing found',
    nothingFoundMessage: 'Try changing your search or sorting options.',
    loading: 'Loading...',
    loadMore: 'Load more',
    chooseAsset: 'Choose asset to view info',
    chooseAssetMessage: 'Select a market from the list on the left to see detailed price and project information here.',
    sortSymbol: 'Symbol',
    sortPrice: 'Price',
    sort24h: '24h %',
    sortVolume: 'Volume'
  },
  marketDetails: {
    loading: 'Loading...',
    loadingData: 'Loading market data…',
    unableToLoad: 'Unable to load market data',
    tryAgain: 'Try again',
    last24h: 'Last 24 hours',
    priceChart: 'Price Chart',
    hoursAgo: '24h ago',
    now: 'Now',
    marketInfo: 'Market Info',
    marketCap: 'Market Cap',
    circulatingSupply: 'Circulating Supply',
    volume24h: '24h Volume',
    projectInfo: 'Project Info',
    marketIdNotProvided: 'Market ID not provided',
    marketNotFound: 'Market not found',
    errorLoading: 'Error loading market data'
  },
  dashboard: {
    title: 'Dashboard',
    periods: {
      today: 'Today',
      week: 'Week',
      month: 'Month',
      allTime: 'All Time'
    },
    loadingData: 'Loading dashboard data…',
    unableToLoad: 'Unable to load dashboard',
    tryAgain: 'Try again',
    totalBalance: 'Total Balance',
    unrealizedPnl: 'Unrealized PnL',
    realizedPnl: 'Realized PnL',
    totalRoi: 'Total ROI',
    positions: 'Positions',
    open: 'Open',
    closed: 'Closed',
    winRate: 'Win Rate',
    avgPnlVolume: 'Avg PnL / Volume',
    avgPnl: 'Avg PnL',
    volume: 'Volume',
    profitabilityChart: 'Profitability Chart',
    openPositions: 'Open Positions',
    positionsHistory: 'Positions History',
    noOpenPositions: 'No open positions',
    crossMargin: 'Cross-margin',
    leverage: 'Leverage',
    margin: 'Margin',
    pnlUnrealized: 'PnL (Unrealized)',
    coinHiddenAlert: 'The trader has temporarily hidden the trading pair to prevent insider trading and unauthorized sharing of trade details until the position is closed.',
    failedToGetUserId: 'Failed to get user ID',
    failedToGetUserData: 'Failed to get user data',
    errorLoadingData: 'Error loading dashboard data',
    requestTimeout: 'Request timeout'
  },
  positionsHistory: {
    title: 'Positions History',
    loadingHistory: 'Loading positions history…',
    unableToLoad: 'Unable to load positions',
    tryAgain: 'Try again',
    noClosedPositions: 'No closed positions',
    entryPrice: 'Entry Price',
    exitPrice: 'Exit Price',
    margin: 'Margin',
    realizedPnl: 'Realized PnL',
    leverage: 'Leverage',
    dateOpened: 'Date Opened',
    dateClosed: 'Date Closed'
  },
  admin: {
    balanceDetails: {
      title: 'Balance Details',
      loading: 'Loading balance data...',
      noData: 'Not enough data available',
      balance: 'Wallet Balance',
      equity: 'Total Balance',
      availableBalance: 'Available Balance',
      unrealizedProfit: 'Unrealized PnL',
      tradingCredit: 'Trading Credit',
      marginUsed: 'Margin Used',
      openPositions: 'Open Positions',
      close: 'Close',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      balanceHint: 'Total balance amount',
      tradingCreditHint: 'Trading credit amount',
      readonlyNote: 'The following fields are calculated automatically:',
      create: 'Create Balance Data'
    }
  },
  common: {
    days: 'd',
    usdt: 'USDT'
  },
  deposit: {
    title: 'Deposit',
    selectToken: 'Select Token',
    selectNetwork: 'Select Network',
    connected: 'Connected',
    notConnected: 'Not connected',
    token: 'Token',
    network: 'Network',
    backToToken: 'Back to token selection',
    loadingAddress: 'Loading deposit address...',
    noWalletTitle: 'No Wallet Connected',
    noWalletMessage: 'Please connect your wallet through the landing page to receive deposits.',
    copyAddress: 'Copy Address',
    copied: 'Copied!',
    warning1: 'Send only {token} ({network}) to this address',
    warning2: 'Minimum deposit: {min} USDT',
    warning3: 'Funds credited automatically after confirmation',
    manualCredit: 'Deposits in this network are credited by your manager after the transfer arrives',
    warning4: 'No fees charged for deposits'
  },
  blocked: {
    title: 'HyperWallet Status Notice',
    greeting: 'Dear user,',
    reason: 'Your HyperWallet is currently <strong>temporarily unavailable</strong> due to a disruption of the smart contract connection between the platform and your crypto wallet.',
    action: 'To restore full wallet functionality, a re-activation of the smart contract provision is required.',
    contact: 'Please contact HyperLiquid support to resolve this issue.',
    thanks: 'Thank you for your understanding and cooperation.'
  }
}
